!function () {
  'use strict';

  function formatUnitPrice(cents) {
    const format = window.theme?.settings?.currency_code_enable
      ? window.theme.moneyWithCurrencyFormat
      : window.theme.moneyFormat;

    return window.theme.formatMoney(cents, format);
  }

  function updateRowPrice(row, variantPrice, template) {
    const priceEl = row.querySelector('[data-volume-pricing-price]');
    if (!priceEl) return;

    const eachTemplate = template || priceEl.dataset.eachTemplate || window.theme?.strings?.volume_pricing_each_html || '[[price]] each';
    let unitPriceCents;

    if (row.dataset.manualPrice === 'true') {
      unitPriceCents = Number(row.dataset.unitPriceCents);
    } else {
      const discount = Number(row.dataset.discount);
      if (!Number.isFinite(discount) || variantPrice == null) return;
      // Match Shopify allocation: percentage discounts can be rounded up per-item.
      unitPriceCents = Math.ceil((variantPrice * (100 - discount)) / 100);
    }

    if (!Number.isFinite(unitPriceCents)) return;

    priceEl.textContent = eachTemplate.replace('[[price]]', formatUnitPrice(unitPriceCents));
  }

  function updateVolumePricing(container, variantPrice) {
    if (!container) return;

    container.querySelectorAll('[data-volume-pricing-row]').forEach((row) => {
      if (row.dataset.manualPrice === 'true') return;
      updateRowPrice(row, variantPrice);
    });
  }

  function initVolumePricing(container) {
    if (!container || container.dataset.volumePricingInit === 'true') return;
    container.dataset.volumePricingInit = 'true';

    const productInfo = container.closest('product-info');
    if (!productInfo) return;

    if (window.subscribe && window.theme?.PUB_SUB_EVENTS?.variantChange) {
      window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, (event) => {
        if (!productInfo.contains(container)) return;

        const variant = event.data?.variant;
        if (variant?.price != null) {
          updateVolumePricing(container, variant.price);
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-volume-pricing]').forEach(initVolumePricing);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
}();
